// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3efuj","left":"InfoRow_left__314X4"};